// src/pages/LinkedInCallback.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastError, ToastSuccess } from 'src/component/uiElements/toast';

import { GoogleLogin as GOOGLE_LOGIN } from 'src/component/api/property_type/propertType';

const LinkedInCallback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleLinkedInLogin = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            console.log("code---", code, params);
            const state = params.get('state');

            if (!code) {
                ToastError("Login failed or cancelled.");
                return;
            }

            const response = await GOOGLE_LOGIN({ code }); // You send `code` to backend

            if (!response?.status) {
                let fail = JSON.parse(response?.data!);
                ToastError(fail.Message);
                return;
            }

            let result = JSON.parse(response?.data!);
            ToastSuccess(result.Message);
            localStorage.setItem('SignInUser', "True");
            navigate('/home');
        };

        handleLinkedInLogin();
    }, []);

    return <div>Logging you in with LinkedIn...</div>;
};

export default LinkedInCallback;
